// you can import modules from the theme lib or even from
// NPM packages if they support it…
//import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
//const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
//import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from './components/AnimateOnPageLinks';
//import Nav from "./components/Nav";

// Nav menus
import Navigation from '@10up/component-navigation';

new Navigation( '.primary-menu', {
    action: 'click',
    breakpoint: '(min-width: 1280px)',
} );

//import getQueryVar from './components/getQueryVar';
//import './components/gmaps';
//import './components/gmaps-mls';
import StickyMenu from './components/sticky-menu';
import Slick from './components/slick';
import SlickLightbox from './components/slick-lightbox';
import SlickInit from './components/slick-init';
import wsFormEvents from './components/wsFormEvents';

import A11yDialog from 'a11y-dialog';

if ( document.getElementById('search-filters') ) {
    // Get the dialog element (with the accessor method you want)
    const el = document.getElementById('search-filters');

    // Instantiate a new A11yDialog module
    const dialog = new A11yDialog(el);
}
// Initialise our components on jQuery.ready…
jQuery(function ($) {
    //ExampleComponent1.init();
    //ExampleModule2.init();
    //ReplaceObfuscatedEmailAddresses.init();
    AnimateOnPageLinks.init();
});